import sha256 from 'crypto-js/sha256'
import base64 from 'crypto-js/enc-base64'
import { logError } from 'helpers/log'

let codeVerifier = ''

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const base64url = (source: any): string => {
  // Encode in classical base64
  let encodedSource = base64.stringify(source)

  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, '')

  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, '-')
  encodedSource = encodedSource.replace(/\//g, '_')

  return encodedSource
}

const generateRandomNumber = () => {
  /*
   * With Math.random, it generate floating points that have a 32-bit random mantissa , therefore creating
   * a 32 bit typed array
   */
  const randomNumberArray = new Uint32Array(1)
  window.crypto.getRandomValues(randomNumberArray)
  /*
   * Dividing the generated random number by 2**32 to reduce down the value between 0 and 1.
   * Provided that 0 is inclusive and 1 is exclusive
   */
  return randomNumberArray[0] / 2 ** 32
}

const generateRandomAlphaNumericString = (L: number): string => {
  function c(): number | string {
    return Math.floor(generateRandomNumber() * 5) < 1
      ? Math.floor(generateRandomNumber() * 10) + 48
      : String.fromCharCode(
          65 +
            Math.floor(generateRandomNumber() * 26) +
            Math.floor(generateRandomNumber() * 2) * 32
        )
  }
  let i
  let s = ''
  // eslint-disable-next-line no-param-reassign
  L = L || Math.floor(generateRandomNumber() * 7) + 8
  // eslint-disable-next-line no-plusplus
  for (i = 0; i < L; i++) {
    s += c()
  }
  return s
}

const chosenLength = Math.floor(generateRandomNumber() * (128 - 43)) + 43

/**
 * Creates a new code verifier
 */
const createCodeVerifier = () => {
  codeVerifier = generateRandomAlphaNumericString(chosenLength)
}

/**
 * @returns codeVerifier
 */
export const getCodeVerifier = () => {
  if (!codeVerifier) {
    logError('Code verifier does not exist , generating a new one!')
    createCodeVerifier()
  }
  return codeVerifier
}

/**
 * Used to get the code challenge using code verifier
 * @returns codeChallenge
 */
export const getCodeChallenge = () => {
  const enCodedValue = sha256(getCodeVerifier())
  return base64url(enCodedValue)
}
